// @ts-nocheck
import React, { Children, cloneElement } from 'react';
import classNames from 'classnames';
import styles from '../style.module.css';

function Body(props : any) {
  const { children, className } = props;

  return (
    <div className={classNames(styles.tabBody, className)}>
      {Children.map(children, (child, index) => (
        cloneElement(child, { index })
      ))}
    </div>
  );
}

Body.defaultProps = {
  className: null,
};


export default Body;
